import * as React from 'react';

function SvgInstagramIcon(props) {
  return (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <circle cx={16} cy={16} r={16} fill="#000" />
      <path
        d="M20.009 12.887a.889.889 0 10-.002-1.778.889.889 0 00.002 1.778zM16.057 12.255c-2.062 0-3.752 1.693-3.752 3.76 0 2.065 1.69 3.758 3.752 3.758s3.752-1.693 3.752-3.759-1.69-3.76-3.752-3.76zm0 6.17a2.423 2.423 0 01-2.406-2.41c0-1.32 1.088-2.411 2.406-2.411a2.423 2.423 0 012.406 2.41c0 1.32-1.088 2.41-2.406 2.41z"
        fill="#fff"
      />
      <path
        d="M19.036 23.619h-6.072c-2.52 0-4.583-2.066-4.583-4.592v-6.055c0-2.525 2.062-4.591 4.583-4.591h6.072c2.52 0 4.583 2.066 4.583 4.591v6.084c-.029 2.525-2.062 4.563-4.583 4.563zM12.964 9.816a3.145 3.145 0 00-3.151 3.156v6.084c0 1.722 1.403 3.157 3.15 3.157h6.073a3.163 3.163 0 003.15-3.157v-6.084c0-1.721-1.403-3.156-3.15-3.156h-6.072z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgInstagramIcon;
